import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * État vide (§13 : « les erreurs et les états vides disent-ils quoi faire ? »).
 * Un état vide sans issue est un cul-de-sac : il porte donc toujours un titre,
 * une explication, et l'action qui en sort quand elle existe.
 */
export function EtatVide({ titre, texte, action, }) {
    return (_jsx("div", { className: "panneau", children: _jsxs("div", { className: "etat-vide", children: [_jsx("p", { className: "etat-vide__titre", children: titre }), _jsx("p", { children: texte }), action] }) }));
}
//# sourceMappingURL=EtatVide.js.map